export default __webpack_public_path__ + "static/media/onepiece.523f830d.mp3";